import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import Footer from "../../../components/footer/Footer";
import Navbar from "../../../components/navbar/navbar";

import generalCargoImg from "../../../assets/imgs/services/international/general.jpg";
import alertImg from "../../../assets/imgs/prepare-shipment/general_cargo/alert-icon.png";
import boxIcon from "../../../assets/imgs/prepare-shipment/general_cargo/box-icon.svg";
import dropIcon from "../../../assets/imgs/prepare-shipment/general_cargo/drop-icon.svg";
import cupIcon from "../../../assets/imgs/prepare-shipment/general_cargo/cup-icon.svg";
import letterIcon from "../../../assets/imgs/prepare-shipment/general_cargo/letter-icon.svg";
import heavyIcon from "../../../assets/imgs/prepare-shipment/general_cargo/heavy-icon.svg";

import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";

import "./gen-cargo-main.css";

import axios from "axios";

function GenCargoMain() {
  const { t } = useTranslation("genCargoPage");
  const [tSMetaData] = useTranslation("metaData");

  useEffect(() => {
    sessionStorage.setItem(
      "routeEs",
      `/${navBarEs["category-services"].shipments}/${
        Object.keys(navBarEs["prepare-shipment-submenu"])[1]
      }`
    );

    sessionStorage.setItem(
      "routeEn",
      `/${navBarEn["category-services"].shipments}/${
        Object.keys(navBarEn["prepare-shipment-submenu"])[1]
      }`
    );
  }, []);

  const cargoData = [
    {
      icon: boxIcon,
      title: t("cargo-types.dry.title"),
      items: t("cargo-types.dry.items", { returnObjects: true }) || [],
      noteTitle: t("cargo-types.dry.noteTitle"),
      notes: t("cargo-types.dry.notes", { returnObjects: true }) || [],
    },
    {
      icon: dropIcon,
      title: t("cargo-types.wet.title"),
      items: t("cargo-types.wet.items", { returnObjects: true }) || [],
      noteTitle: t("cargo-types.wet.noteTitle"),
      notes: t("cargo-types.wet.notes", { returnObjects: true }) || [],
    },
    {
      icon: cupIcon,
      title: t("cargo-types.fragile.title"),
      items: t("cargo-types.fragile.items", { returnObjects: true }) || [],
      noteTitle: t("cargo-types.fragile.noteTitle"),
      notes: t("cargo-types.fragile.notes", { returnObjects: true }) || [],
    },
    {
      icon: letterIcon,
      title: t("cargo-types.courier.title"),
      paragraph: t("cargo-types.courier.paragraph"),
    },
    {
      icon: heavyIcon,
      title: t("cargo-types.heavy.title"),
      paragraph: t("cargo-types.heavy.paragraph"),
    },
  ];

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].shipments}/${
      Object.keys(navBarEs["prepare-shipment-submenu"])[1]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].shipments}/${
      Object.keys(navBarEn["prepare-shipment-submenu"])[1]
    }`
  );

  return (
    <div>
      <Helmet>
        <title>{tSMetaData("preparaEmbarqueCargaGeneral.title")}</title>
        <meta
          name="description"
          content={tSMetaData("preparaEmbarqueCargaGeneral.description")}
        />
      </Helmet>
      <Navbar />
      {/* <TitleSection title={tGenCargo("general-cargo.general-cargo")} /> */}
      <div className="container-fluid blue-container">
        <div className="row justify-content-center align-items-center full-height-row">
          {/* Usamos col-auto para que la columna se ajuste al contenido central */}
          <div className="col-auto">
            <div className="service-content-wrapper">
              <div className="image-circle-container">
                <img src={generalCargoImg} alt={t("general-cargo.general-cargo")}  className="cargo-image-rounded" />
              </div>
              <div className="text-container">
                <h4 className="service-title">{t("general-cargo.general-cargo-title")}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid" style={{backgroundColor: '#F2F2EE'}}>
        <div className="container note-container">
          <div className="row">
            <div className="col">
              <div className="note-icon">
                <img src={alertImg} alt="Alert Icon" />
                <p>{t("general-cargo.note")}</p>
              </div>
              <div className="note-text">
                {t("general-cargo.text-1")}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container cargo-container my-5">
        {/* row-cols-1 para móviles, row-cols-md-3 para tablets, row-cols-lg-5 para PC */}
        <div className="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-0">
          
          {cargoData.map((cargo, index) => (
            <div className="col cargo-card-wrapper" key={index}>
              <div className="cargo-card">
                
                {/* Contenedor del Icono */}
                <div className="cargo-icon-box mx-auto">
                  <img src={cargo.icon} alt={cargo.title} />
                </div>
                
                {/* Título */}
                <h3 className="cargo-title text-center mt-3">{cargo.title}</h3>
                
                {/* Lista de viñetas (si aplica) */}
                {cargo.items && Array.isArray(cargo.items) && (
                  <ul className="cargo-list">
                    {cargo.items.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}

                {/* Párrafo sin viñetas (para mensajería y carga pesada) */}
                {cargo.paragraph && (
                  <p className="cargo-paragraph">{cargo.paragraph}</p>
                )}

                {/* Sección "Tome en cuenta que" (si aplica) */}
                {cargo.noteTitle && cargo.notes && Array.isArray(cargo.notes) && (
                  <div className="cargo-notes-section">
                    <h4 className="cargo-note-title">{cargo.noteTitle}</h4>
                    <ul className="cargo-list">
                      {cargo.notes.map((note, i) => (
                        <li key={i}>{note}</li>
                      ))}
                    </ul>
                  </div>
                )}

              </div>
            </div>
          ))}

        </div>
        <div className="row mt-5">
          <div className="col text-center">
            <Link id="btnQuoteGeneralCargo" className="btn-quote-pink" to="/quote">
              {t("general-cargo.quote")}
            </Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
}

export default GenCargoMain;
